<template>
  <section class="content">
    <loading :active.sync="isLoading"
      :color="'#39a2db'"
      :loader="'dots'"
      :is-full-page="true"></loading>

    <!-- Toast Pindah Kolom (500ms) -->
    <transition name="fade-toast">
      <div v-if="showPopupPindah" class="toast-pindah">
        <span style="font-size:24px; margin-right:10px;">➡️</span>
        <template v-if="colIndexNow < total_col">Pindah ke Kolom {{ colIndexNow + 1 }}</template>
        <template v-else>Selesai</template>
      </div>
    </transition>

    <div class="row">
      <div class="col-12">
        <div class="container-fluid">
          <!-- Header: Timer + Info Kolom -->
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="text-left">
              <span class="badge badge-info badge-lg" style="font-size:16px; padding: 6px 14px;">
                Kolom {{ colIndexNow }} / {{ total_col }}
              </span>
              <span class="badge badge-secondary badge-lg ml-1 d-inline-block d-sm-none" style="font-size:14px; padding: 6px 14px;">
                Soal {{ soalIniCol + 1 }} / {{ totalSoalIniCol }}
              </span>
            </div>
            <div class="text-right" :class="colTimer <= 60 ? 'text-danger' : 'text-info'">
              <h3 class="mb-0"><i class="fas fa-clock"></i> {{ formatColTimer }}</h3>
            </div>
          </div>

          <!-- Info Soal -->
          <div class="card d-none d-sm-block" style="border: 2px solid #6190E8; max-width: 700px; margin: 0 auto 20px;">
            <div class="card-header text-center" style="background: linear-gradient(90deg, #6190E8, #A7BFE8); color: white; font-weight: 700;">
              Soal {{ soalIniCol + 1 }} / {{ totalSoalIniCol }}
              <span class="ml-3 badge badge-light">{{ terjawabKolomIni }} terjawab</span>
            </div>
          </div>

          <!-- Referensi Simbol -->
          <div class="card ref-card">
            <div class="card-header d-none d-sm-block" style="background: linear-gradient(90deg, #6190E8, #A7BFE8); color: white; font-weight: 700;">
              Referensi Simbol
            </div>
            <div class="card-body p-1">
              <div class="d-flex justify-content-around flex-nowrap overflow-auto py-1">
                <div v-for="item in ref" :key="item.id" class="text-center mx-1 my-1 ref-item">
                  <span class="ref-symbol" v-html="item.symbol"></span>
                  <br>
                  <span class="ref-number">{{ item.angka }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Soal -->
          <div v-if="currentSoal" class="card soal-card">
            <div class="card-body text-center p-2">
              <div class="soal-text">
                <template v-for="(sym, si) in currentSoal.symbols">
                  <span :key="si" v-html="sym"></span>
                  <span :key="'plus-'+si" v-if="si < currentSoal.symbols.length - 1" class="soal-plus"> + </span>
                </template>
                <span class="soal-equals"> = ?</span>
              </div>

              <!-- Bottom Docked Area (Fixed/docked to bottom on mobile, normal on desktop) -->
              <div class="bottom-dock">
                <!-- Input field for FULL mode -->
                <div v-if="answerMode === 'full'" class="mb-2 mb-sm-3">
                  <input
                    ref="jawabanInput"
                    type="text"
                    :inputmode="useSystemKeyboard ? 'numeric' : 'none'"
                    pattern="[0-9]*"
                    class="form-control form-control-lg text-center input-jawaban"
                    v-model="fullJawaban"
                    placeholder="0"
                    @keyup.enter="submitAnswer"
                    maxlength="2"
                    @input="onFullInput"
                    autofocus
                    :readonly="showPopupPindah || isLoading || sudahKirim"
                  />
                </div>

                <!-- Keypad Numpad -->
                <div class="row" style="max-width: 300px; margin: 0 auto;">
                  <div class="col-4 p-1" v-for="n in [1,2,3]" :key="'r1-'+n">
                    <button class="btn btn-block btn-keypad btn-outline-secondary" @click="inputNumber(n)">{{ n }}</button>
                  </div>
                  <div class="col-4 p-1" v-for="n in [4,5,6]" :key="'r2-'+n">
                    <button class="btn btn-block btn-keypad btn-outline-secondary" @click="inputNumber(n)">{{ n }}</button>
                  </div>
                  <div class="col-4 p-1" v-for="n in [7,8,9]" :key="'r4-'+n">
                    <button class="btn btn-block btn-keypad btn-outline-secondary" @click="inputNumber(n)">{{ n }}</button>
                  </div>
                  <div class="col-4 p-1">
                    <button
                      type="button"
                      class="btn btn-block btn-keypad"
                      :class="useSystemKeyboard ? 'btn-info text-white' : 'btn-outline-secondary'"
                      @click="toggleKeyboardMode"
                      :title="useSystemKeyboard ? 'Keypad Sistem (Klik untuk ke Web Keypad)' : 'Web Keypad (Klik untuk ke Keypad Sistem)'"
                      style="font-size: 14px; padding: 8px 2px; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%;"
                    >
                      <i :class="useSystemKeyboard ? 'fas fa-keyboard' : 'fas fa-calculator'" style="font-size: 20px;"></i>
                      <span style="font-size: 10px; line-height: 1.1; margin-top: 2px; font-weight: 700;">
                        {{ useSystemKeyboard ? 'Sistem' : 'Web' }}
                      </span>
                    </button>
                  </div>
                  <div class="col-4 p-1">
                    <button class="btn btn-block btn-keypad btn-outline-secondary" @click="inputNumber(0)">0</button>
                  </div>
                  <div class="col-4 p-1">
                    <button class="btn btn-block btn-keypad btn-outline-secondary" @click="hapusDigit"><i class="fas fa-eraser"></i></button>
                  </div>
                </div>

                <!-- Submit button for FULL mode -->
                <div v-if="answerMode === 'full'" class="mt-2 mt-sm-3 mb-1 mb-sm-2">
                  <button class="btn btn-success btn-lg btn-block btn-submit" style="max-width: 300px; margin: 0 auto;" @click="submitAnswer" :disabled="fullJawaban === '' || fullJawaban === null">
                    <i class="fas fa-check"></i> Submit Jawaban
                  </button>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const STORAGE_PREFIX = 'simbol_session_';

export default {
  name: "UjianProcessSimbolAritmatika",
  data() {
    return {
      isLoading: false,
      kode: '',
      paket: {},
      ref: [],
      all_soal: [],        // all questions [{id, sequence, col_index, symbols, jawaban, is_answered}]
      total_soal: 0,
      total_col: 1,
      currentCol: 1,        // kolom aktif (1-based), independen dari urutan all_soal
      hasil_id: null,
      colTimerDuration: 0, // per-column duration in seconds
      colTimer: 0,         // current column countdown in seconds
      colStartTime: 0,     // timestamp when current column started
      currentSoalIdx: 0,   // index into all_soal
      intervalId: null,
      answerMode: 'full',
      fullJawaban: '',
      sudahKirim: false,
      showPopupPindah: false,
      pindahTimeout: null,
      useSystemKeyboard: false, // default web keypad (false) for mobile & desktop
    };
  },
  watch: {
    currentSoalIdx() {
      this.focusInput();
    },
    answerMode() {
      this.focusInput();
    },
    currentSoal(newVal) {
      if (newVal) {
        this.focusInput();
      }
    },
  },
  created() {
    this.kode = this.$route.params.id;
    if (!this.restoreFromStorage()) {
      this.loadSoalFromApi();
    } else {
      // Arahkan ke soal pertama di currentCol (backward compat)
      this.$nextTick(() => {
        this.tujuKeKolom(this.currentCol);
      });
    }
  },
  mounted() {
    this.startTimer();
    window.addEventListener('keydown', this.handleGlobalKeyDown);
    this.focusInput();
    if (this.isMobile) {
      document.body.classList.add('mobile-exam-mode');
    }
  },
  beforeDestroy() {
    this.stopTimer();
    window.removeEventListener('keydown', this.handleGlobalKeyDown);
    if (this.pindahTimeout) {
      clearTimeout(this.pindahTimeout);
      this.pindahTimeout = null;
    }
    this.saveToStorage();
    if (this.isMobile) {
      document.body.classList.remove('mobile-exam-mode');
    }
  },
  components: { Loading },
  methods: {
    focusInput(forceRefocus = false) {
      this.$nextTick(() => {
        if (this.answerMode === 'full' && this.$refs.jawabanInput) {
          try {
            if (forceRefocus) {
              this.$refs.jawabanInput.blur();
              setTimeout(() => {
                if (this.$refs.jawabanInput) {
                  this.$refs.jawabanInput.focus();
                }
              }, 50);
            } else {
              this.$refs.jawabanInput.focus();
            }
          } catch(e) {}
        }
      });
    },
    toggleKeyboardMode() {
      this.useSystemKeyboard = !this.useSystemKeyboard;
      this.saveToStorage();
      this.focusInput(true);
    },
    handleGlobalKeyDown(e) {
      if (this.showPopupPindah || this.isLoading || this.sudahKirim) return;
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT')) {
        if (e.target === this.$refs.jawabanInput) {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.submitAnswer();
          }
          return;
        }
      }

      if (e.key >= '0' && e.key <= '9') {
        if (this.answerMode === 'modulo10') {
          e.preventDefault();
          this.inputNumber(parseInt(e.key, 10));
        } else if (this.answerMode === 'full') {
          e.preventDefault();
          this.inputNumber(parseInt(e.key, 10));
        }
      } else if (e.key === 'Backspace') {
        if (this.answerMode === 'full') {
          e.preventDefault();
          this.hapusDigit();
        }
      } else if (e.key === 'Enter') {
        if (this.answerMode === 'full') {
          e.preventDefault();
          this.submitAnswer();
        }
      }
    },
    // ---------- TIMER ----------
    startTimer() {
      this.stopTimer();
      this.intervalId = setInterval(() => {
        if (this.showPopupPindah) return;
        if (this.colTimer > 0) {
          this.colTimer--;
          if (this.colTimer % 5 === 0) {
            this.saveToStorage();
          }
          // Column time expired
          if (this.colTimer === 0 && this.hasil_id && !this.sudahKirim) {
            this.onColumnTimeUp();
          }
        }
      }, 1000);
    },
    stopTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    // ---------- COLUMN TRANSITION ----------
    onColumnTimeUp() {
      this.stopTimer();
      this.showPopupPindah = true;
      this.pindahTimeout = setTimeout(() => {
        this.pindahTimeout = null;
        this.pindahKeKolomBerikutnya();
      }, 500);
    },
    // ---------- NAVIGASI KOLOM ----------
    tujuKeKolom(col) {
      // Cari soal pertama di kolom ini
      var idx = this.all_soal.findIndex(function(s) { return s.col_index === col; });
      if (idx >= 0) {
        this.currentCol = col;
        this.currentSoalIdx = idx;
        this.focusInput();
        return true;
      }
      return false;
    },

    pindahKeKolomBerikutnya() {
      this.showPopupPindah = false;

      var nextCol = this.currentCol + 1;

      if (nextCol > this.total_col) {
        // All columns done - auto finish
        this.submitAndFinish();
        return;
      }

      if (this.tujuKeKolom(nextCol)) {
        // Reset column timer
        this.colTimer = this.colTimerDuration;
        this.colStartTime = Math.floor(Date.now() / 1000);
        this.resetFullJawaban();
        this.saveToStorage();
        // Resume timer
        this.startTimer();
        this.focusInput();
      } else {
        this.submitAndFinish();
      }
    },

    // ---------- STORAGE ----------
    storageKey() {
      return STORAGE_PREFIX + this.kode;
    },
    saveToStorage() {
      if (!this.hasil_id || this.sudahKirim) return;
      var data = {
        kode: this.kode,
        paket: this.paket,
        ref: this.ref,
        all_soal: this.all_soal.map(function(s) {
          return {
            id: s.id,
            sequence: s.sequence,
            col_index: s.col_index,
            symbols: s.symbols,
            jawaban: s.jawaban,
            is_answered: s.is_answered,
          };
        }),
        total_soal: this.total_soal,
        total_col: this.total_col,
        currentCol: this.currentCol,
        hasil_id: this.hasil_id,
        colTimerDuration: this.colTimerDuration,
        colTimer: this.colTimer,
        colStartTime: this.colStartTime,
        currentSoalIdx: this.currentSoalIdx,
        answerMode: this.answerMode,
        useSystemKeyboard: this.useSystemKeyboard,
      };
      try {
        localStorage.setItem(this.storageKey(), JSON.stringify(data));
      } catch(e) {}
    },
    clearStorage() {
      try {
        localStorage.removeItem(this.storageKey());
      } catch(e) {}
    },
    restoreFromStorage() {
      try {
        var raw = localStorage.getItem(this.storageKey());
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (!data.hasil_id) return false;

        this.paket = data.paket || {};
        this.ref = data.ref || [];
        this.all_soal = data.all_soal || [];
        this.total_soal = data.total_soal || 0;
        this.total_col = data.total_col || 1;
        this.currentCol = data.currentCol || 1;
        this.hasil_id = data.hasil_id;
        this.colTimerDuration = data.colTimerDuration || 180;
        this.colStartTime = data.colStartTime || Math.floor(Date.now() / 1000);
        this.currentSoalIdx = data.currentSoalIdx || 0;
        this.answerMode = data.answerMode || 'full';
        this.useSystemKeyboard = data.useSystemKeyboard !== undefined ? data.useSystemKeyboard : false;

        // Calculate remaining column time
        var elapsed = Math.floor(Date.now() / 1000) - this.colStartTime;
        this.colTimer = Math.max(0, this.colTimerDuration - elapsed);

        if (this.colTimer <= 0 || this.isColumnComplete) {
          this.onColumnTimeUp();
        }

        this.isLoading = false;
        return true;
      } catch(e) {
        return false;
      }
    },

    // ---------- LOAD ----------
    loadSoalFromApi() {
      this.isLoading = true;
      authFetch("/siswa/test/simbol_aritmatika_soal/" + this.kode).then((res) => {
        res.json().then((json) => {
          this.isLoading = false;
          if (json.success) {
            this.paket = json.data.paket;
            this.ref = json.data.ref;
            this.answerMode = (json.data.paket && json.data.paket.answer_mode) || 'full';
            this.all_soal = json.data.all_soal || [];
            this.total_soal = json.data.total_soal || 0;
            this.total_col = json.data.total_col || 1;
            this.hasil_id = json.data.hasil_id;

            // Per-column duration from paket.total_duration (minutes), default 3 min
            var perKolomMenit = parseInt(json.data.paket && json.data.paket.total_duration) || 3;
            this.colTimerDuration = perKolomMenit * 60;
            this.colTimer = this.colTimerDuration;
            this.colStartTime = Math.floor(Date.now() / 1000);

            // Mulai dari kolom 1: cari soal pertama dengan col_index = 1
            this.currentCol = 1;
            this.tujuKeKolom(1);
            this.resetFullJawaban();
            this.saveToStorage();
          } else {
            if (json.expired) {
              Swal.fire("Waktu Habis", json.message || "Waktu pengerjaan telah habis.", "info");
            } else {
              Swal.fire("Error", "Gagal memuat soal.", "error");
            }
          }
        });
      }).catch(() => {
        this.isLoading = false;
        Swal.fire("Error", "Gagal terhubung ke server.", "error");
      });
    },

    // ---------- NAVIGASI SOAL (auto-advance, one direction) ----------
    advanceToNextSoal() {
      // Try to find next unanswered question in current column
      var ci = this.currentCol;
      for (var i = this.currentSoalIdx + 1; i < this.all_soal.length; i++) {
        if (this.all_soal[i].col_index === ci && !this.all_soal[i].is_answered) {
          this.currentSoalIdx = i;
          this.resetFullJawaban();
          this.focusInput();
          return true;
        }
      }
      // All questions in current column answered → column complete
      return false;
    },

    // ---------- INPUT / JAWAB ----------
    inputNumber(n) {
      if (n === null || n === undefined) return;
      if (this.answerMode === 'modulo10') {
        this.answerSoal(n);
      } else {
        // Full mode: max 2 digits
        var strVal = String(this.fullJawaban || '');
        if (strVal.length < 2) {
          this.fullJawaban = strVal + String(n);
        }
        this.focusInput();
      }
    },
    hapusDigit() {
      var strVal = String(this.fullJawaban || '');
      if (strVal.length > 0) {
        this.fullJawaban = strVal.slice(0, -1);
      }
      this.focusInput();
    },
    onFullInput(e) {
      // Limit to 2 digit characters only
      var val = String(this.fullJawaban || '').replace(/\D/g, '');
      if (val.length > 2) {
        val = val.slice(0, 2);
      }
      this.fullJawaban = val;
      if (e && e.target) {
        e.target.value = val;
      }
    },
    resetFullJawaban() {
      this.fullJawaban = '';
      this.focusInput();
    },

    answerSoal(jawaban) {
      var item = this.all_soal[this.currentSoalIdx];
      if (!item) return;

      item.is_answered = true;
      item.jawaban = jawaban;
      this.saveToStorage();

      // Auto-advance
      var hasMore = this.advanceToNextSoal();
      if (!hasMore) {
        // Column complete → show Pindah toast 500ms
        this.stopTimer();
        this.showPopupPindah = true;
        this.pindahTimeout = setTimeout(() => {
          this.pindahTimeout = null;
          this.pindahKeKolomBerikutnya();
        }, 500);
      }
    },

    submitAnswer() {
      if (this.answerMode !== 'full') return;
      if (this.fullJawaban === '' || this.fullJawaban === null) return;
      var jawaban = parseInt(this.fullJawaban, 10);
      if (isNaN(jawaban)) return;

      this.answerSoal(jawaban);
    },

    // ---------- FINISH ----------
    submitAndFinish() {
      if (this.sudahKirim || !this.hasil_id) return;
      this.sudahKirim = true;
      this.isLoading = true;
      this.stopTimer();
      this.clearStorage();

      var answers = this.all_soal.map(function(item) {
        return {
          jawaban_id: item.id,
          jawaban: item.jawaban,
        };
      });

      authFetch("/siswa/test/simbol_aritmatika_submit_batch", {
        method: "POST",
        body: JSON.stringify({
          hasil_id: this.hasil_id,
          answers: answers,
        }),
      }).then((res) => res.json()).then((json) => {
        this.isLoading = false;
        if (json.success) {
          sessionStorage.setItem('hasil_simbol_id', this.hasil_id);
          this.$router.push({ path: '/rekap-hasil-simbol-aritmatika', query: { hasil_id: this.hasil_id } });
        } else {
          this.sudahKirim = false;
          Swal.fire("Gagal", json.message || "Terjadi kesalahan saat mengirim jawaban.", "error");
        }
      }).catch(() => {
        this.isLoading = false;
        this.sudahKirim = false;
        Swal.fire("Error", "Gagal terhubung ke server.", "error");
      });
    },
  },
  computed: {
    isMobile() {
      if (typeof window === 'undefined') return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
    },
    // ---------- COLUMN TRACKING ----------
    colIndexNow() {
      return this.currentCol;
    },
    totalSoalIniCol() {
      var ci = this.currentCol;
      return this.all_soal.filter(function(s) { return s.col_index === ci; }).length;
    },
    soalIniCol() {
      var ci = this.currentCol;
      var inCol = this.all_soal.filter(function(s) { return s.col_index === ci; });
      for (var i = 0; i < inCol.length; i++) {
        if (this.all_soal[this.currentSoalIdx] === inCol[i]) return i;
      }
      return 0;
    },
    terjawabKolomIni() {
      var ci = this.currentCol;
      return this.all_soal.filter(function(s) { return s.col_index === ci && s.is_answered; }).length;
    },
    isLastColumn() {
      return this.currentCol >= this.total_col;
    },
    isColumnComplete() {
      return this.terjawabKolomIni >= this.totalSoalIniCol;
    },
    currentSoal() {
      if (this.currentSoalIdx >= 0 && this.currentSoalIdx < this.all_soal.length) {
        return this.all_soal[this.currentSoalIdx];
      }
      return null;
    },
    formatColTimer() {
      if (this.colTimer <= 0) return '00:00';
      const minutes = Math.floor(this.colTimer / 60);
      const seconds = this.colTimer % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.btn-keypad {
  font-size: 24px;
  font-weight: 700;
  padding: 15px;
  border-radius: 12px;
  transition: all 0.2s;
}
.btn-keypad:hover {
  transform: scale(1.05);
}
.btn-keypad:active {
  transform: scale(0.95);
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}

/* Toast Pindah */
.toast-pindah {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  font-size: 28px;
  font-weight: 700;
  padding: 18px 36px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.4);
  z-index: 9999;
  display: flex;
  align-items: center;
  pointer-events: none;
  white-space: nowrap;
}
.fade-toast-enter-active {
  animation: toast-in 0.2s ease-out;
}
.fade-toast-leave-active {
  animation: toast-out 0.2s ease-in;
}
@keyframes toast-in {
  from { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
  to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
}
@keyframes toast-out {
  from { opacity: 1; transform: translate(-50%, -50%) scale(1); }
  to { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
}

/* Responsive UI adjustments */
.ref-card {
  border: 2px solid #6190E8;
  max-width: 700px;
  margin: 0 auto 20px;
}
.ref-symbol {
  font-size: 32px;
}
.ref-number {
  font-weight: 700;
  font-size: 16px;
}
.soal-card {
  border: 2px solid #6190E8;
  max-width: 500px;
  margin: 0 auto;
}
.soal-text {
  font-size: 56px;
  letter-spacing: 16px;
  padding-bottom: 20px;
}
.soal-plus {
  font-size: 28px;
  color: #888;
  vertical-align: middle;
  letter-spacing: 4px;
}
.soal-equals {
  font-size: 24px;
  color: #666;
  letter-spacing: 2px;
}
.input-jawaban {
  font-size: 32px;
  font-weight: 700;
  max-width: 200px;
  margin: 0 auto;
  border: 2px solid #cbdcf7;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.input-jawaban:focus {
  border-color: #6190E8;
  box-shadow: 0 0 8px rgba(97, 144, 232, 0.25);
  outline: none;
}
.bottom-dock {
  background: transparent;
  border-top: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

.btn-keypad {
  font-size: 24px;
  font-weight: 700;
  padding: 15px;
  border-radius: 12px;
  transition: all 0.15s ease;
  background-color: #ffffff;
  border: 1px solid #dcdfe6 !important;
  color: #303133 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
.btn-keypad:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc !important;
}
.btn-keypad:active {
  background-color: #ecf5ff;
  border-color: #b3d8ff !important;
  color: #409eff !important;
  transform: scale(0.95);
}

.btn-keypad.btn-info {
  background-color: #6190E8 !important;
  border-color: #6190E8 !important;
  color: #ffffff !important;
}
.btn-keypad.btn-info:active {
  background-color: #517ed2 !important;
  border-color: #517ed2 !important;
}

.btn-submit {
  background: linear-gradient(90deg, #56ab2f, #a8e063) !important;
  border: none !important;
  color: white !important;
  font-weight: 700;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(86, 171, 47, 0.2);
  transition: all 0.2s ease;
}
.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(86, 171, 47, 0.3);
}
.btn-submit:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(86, 171, 47, 0.15);
}

@media (max-width: 768px) {
  .btn-submit {
    font-size: 16px !important;
    padding: 10px !important;
    border-radius: 10px !important;
  }
  .input-jawaban {
    font-size: 24px !important;
    max-width: 140px !important;
    height: 44px !important;
    border-radius: 8px;
  }
  .ref-card {
    margin: 0 auto 8px !important;
    border: 1px solid #cbdcf7 !important;
    border-radius: 10px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02) !important;
    width: 100%;
  }
  .ref-symbol {
    font-size: 2rem !important;
  }
  .ref-number {
    font-size: 1.2rem !important;
  }
  .ref-item {
    flex: 1 1 0px;
    min-width: 0;
    max-width: 100px !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
  .soal-card {
    margin: 0 auto 5px !important;
  }
  .soal-text {
    font-size: 46px !important;
    letter-spacing: 12px !important;
    padding-bottom: 12px !important;
  }
  .soal-plus {
    font-size: 24px !important;
    letter-spacing: 4px !important;
  }
  .soal-equals {
    font-size: 20px !important;
    letter-spacing: 2px !important;
  }
  .badge-lg {
    font-size: 13px !important;
    padding: 5px 10px !important;
  }
  h3 {
    font-size: 20px !important;
  }
}
</style>

<style>
/* Global css overrides when on mobile exam mode to hide the header navbar & sidebar */
@media (max-width: 768px) {
  body.mobile-exam-mode .main-header,
  body.mobile-exam-mode .main-sidebar,
  body.mobile-exam-mode .content-header,
  body.mobile-exam-mode .main-footer {
    display: none !important;
  }
  body.mobile-exam-mode .content-wrapper {
    margin-top: 0 !important;
    margin-left: 0 !important;
    padding-top: 5px !important;
  }
  
  /* Make the main section container take full viewport height and enforce flex layout */
  body.mobile-exam-mode section.content {
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
    overflow: hidden;
  }
  
  body.mobile-exam-mode section.content > .row {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin: 0 !important;
  }
  
  body.mobile-exam-mode section.content > .row > .col-12 {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 0 !important;
  }

  body.mobile-exam-mode .container-fluid {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 8px !important;
    justify-content: space-between;
  }

  body.mobile-exam-mode .soal-card {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }
  
  body.mobile-exam-mode .soal-card > .card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 4px !important;
  }

  body.mobile-exam-mode .soal-text {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0 !important;
    margin: 0 !important;
  }

  body.mobile-exam-mode .bottom-dock {
    width: 100%;
    background: #ffffff;
    border-top: 2px solid #6190E8;
    border-radius: 16px 16px 0 0;
    padding: 12px 8px 8px;
    box-shadow: 0 -4px 15px rgba(0,0,0,0.08);
  }
}
</style>
